import { Modal } from "@/components/rrhh/ui";

export default function VisorArchivo({ url, onClose, titulo = "Comprobante" }) {
  if (!url) return null;
  const full = `${process.env.REACT_APP_BACKEND_URL}${url}`;
  const esPdf = url.toLowerCase().endsWith(".pdf");
  return (
    <Modal titulo={titulo} onClose={onClose} ancho="max-w-3xl" testid="visor-archivo">
      {esPdf ? (
        <iframe src={full} title="Comprobante PDF" className="h-[72vh] w-full rounded-xl border border-white/10 bg-white" />
      ) : (
        <img src={full} alt="Comprobante" className="max-h-[72vh] w-full rounded-xl border border-white/10 object-contain" />
      )}
    </Modal>
  );
}
